import React, { useEffect, useState } from "react";
import { PauseCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const GiftPausedList = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/giftcards/paused").then(({ data }) => setItems(data.items || [])).catch(() => {});
  }, []);
  if (!items.length) return null;
  const resume = async (it) => {
    await api.delete(`/admin/giftcards/paused/${it.product_id}`);
    setItems((list) => list.filter((x) => x.product_id !== it.product_id));
    toast.success(`${it.brand || it.product_id} di nuovo in vendita`);
  };
  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 space-y-2" data-testid="gift-paused-list">
      <p className="text-sm font-semibold flex items-center gap-2"><PauseCircle className="w-4 h-4 text-amber-500" /> Gift card sospese in automatico</p>
      <p className="text-xs text-muted-foreground">Il fornitore le ha rifiutate 3 volte di seguito: restano nascoste alla rete per 4 ore.</p>
      {items.map((it) => (
        <div key={it.product_id} className="flex flex-wrap items-center justify-between gap-2 text-sm" data-testid={`gift-paused-${it.product_id}`}>
          <span>{it.brand || `#${it.product_id}`} · fino alle {new Date(it.paused_until).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</span>
          <Button size="sm" variant="outline" onClick={() => resume(it)} data-testid={`gift-paused-resume-${it.product_id}`}>Rimetti in vendita</Button>
        </div>
      ))}
    </div>
  );
};
